import React, { Fragment } from 'react';
import {
  f7,
  Page,
  Navbar,
  NavLeft,
  NavRight,
  NavTitle,
  Link,
  Block,
  BlockTitle,
  Toolbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  List,
  ListInput,
  ListItem,
  ListItemCell,
  Icon,
  Button,
  Row,
  Col,
  Checkbox,
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionToggle,
  Popup,
  Toggle,
  Preloader,
  Stepper,
  Range,
  Popover,
  Input,
} from 'framework7-react';

import { MerchantSvg, MealSvg } from '../components/crumbs';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStorage, firestoreConnect } from '../HOCs';
import { DocArray, Collections } from '../utils/_classes';
import {
  handleErrors,
  isEmpty,
  toast,
  generateId,
  uploadFile,
  deleteFile,
} from '../utils/_helpers';

class MerchantProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpened: false,
      popupDataChanged: false,
      popupData: {
        title: '',
        which: '',
      },

      // filter variables
      productFilter: {
        name: '',
        category: 'All',
      },

      // Product
      editProduct: false,
      addProductButton: 'Upload Product Details',
      productImageDisplay: null,
      product: {
        merchantId: props.auth.uid,
        image: null,
        name: '',
        text: '',
        price: '',
        discount: '',
        category: '',
        available: true,
        delivery: true,
        deliveryInclusive: false,
        stocked: '',
        preparationTime: 1440,
        deliveryMeans: 1,
      },

      // Hero
      bannerImageDisplay: null,
      bannerButton: 'Change Banner',
      banner: {
        image: null,
      },

      operatingTime: [
        '12 am',
        '1 am',
        '2 am',
        '3 am',
        '4 am',
        '5 am',
        '6 am',
        '7 am',
        '8 am',
        '9 am',
        '10 am',
        '11 am',
        '12 pm',
        '1 pm',
        '2 pm',
        '3 pm',
        '4 pm',
        '5 pm',
        '6 pm',
        '7 pm',
        '8 pm',
        '9 pm',
        '10 pm',
        '11 pm',
      ],

      operatingDays: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday',
      ],

      storeAvailable: {
        Monday: {
          opens: '6 am',
          close: '11 pm',
          check: true,
        },
        Tuesday: {
          opens: '6 am',
          close: '11 pm',
          check: true,
        },
        Wednesday: {
          opens: '6 am',
          close: '11 pm',
          check: false,
        },
        Thursday: {
          opens: '6 am',
          close: '11 pm',
          check: false,
        },
        Friday: {
          opens: '6 am',
          close: '11 pm',
          check: false,
        },
        Saturday: {
          opens: '6 am',
          close: '11 pm',
          check: false,
        },
        Sunday: {
          opens: '6 am',
          close: '11 pm',
          check: false,
        },
      },
    };
  }

  get preparationTimeComputed() {
    const self = this;
    const value = self.state.product.preparationTime;

    const days = Math.floor(value / 60 / 24);
    const hours = Math.floor((value - days * 60 * 24) / 60);
    const minutes = value - Math.floor(value / 60) * 60;
    const formatted = [];
    if (days > 0) {
      formatted.push(days + ' ' + (days > 1 ? 'days' : 'day'));
    }
    if (hours > 0) {
      formatted.push(hours + ' ' + (hours > 1 ? 'hours' : 'hour'));
    }
    if (minutes > 0) {
      formatted.push(minutes + ' minutes');
    }
    return formatted.join(' ');
  }

  setPreparationTime(value) {
    this.setState({
      ...this.state,
      product: {
        ...this.state.product,
        preparationTime: value,
      },
    });
  }

  render() {
    if (!this.props.merchants[this.props.auth.uid]) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-theme">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0 }}>Become a merchant </h3>
                <Button fill href="/business-registration/1/">
                  Merchant Registration
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <MerchantSvg size="300px" />
              <h6>Earn more profit selling online with Easychaw</h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (this.props.merchants[this.props.auth.uid].accountStatus == 'Pending') {
      return (
        <Page>
          <Block className="pattern-banner bg-color-orange">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: '#ef6c00' }}>
                  Application Pending{' '}
                </h3>
                <Button
                  fill
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <img src="static/relax.svg" style={{ width: '300px' }} />
              <h6>
                Please contact Admin after 24 hours <br /> if account is still
                pending.
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    if (
      this.props.merchants[this.props.auth.uid].accountStatus == 'Suspended'
    ) {
      return (
        <Page>
          <Block className="pattern-banner bg-color-pink">
            <Card style={{ width: '100%', margin: 0 }}>
              <CardHeader>
                <h3 style={{ margin: 0, color: '#E02020' }}>
                  Account Suspended{' '}
                </h3>
                <Button
                  className="button-fill-red"
                  tabLink="#view-message-master"
                  onClick={() =>
                    this.navMessage('account', 'admin', 'account')
                  }>
                  Contact Admin
                </Button>
              </CardHeader>
            </Card>
          </Block>
          <Block>
            <div style={{ textAlign: 'center', marginTop: '10vh' }}>
              <img src="static/cancel.svg" style={{ width: '300px' }} />
              <h6>
                Access Denied <br /> Please contact admin
              </h6>
            </div>
          </Block>
        </Page>
      );
    }

    return (
      <Page>
        {/* Merchant store front  */}
        <div
          className=" store-front-hero"
          style={
            this.props.merchants[this.props.auth.uid].banner
              ? {
                  backgroundImage:
                    'url(' +
                    this.props.merchants[this.props.auth.uid].banner.URL +
                    ')',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }
              : this.state.bannerImageDisplay
              ? {
                  backgroundImage: 'url(' + this.state.bannerImageDisplay + ')',
                }
              : { backgroundImage: 'url(static/banner.png)' }
          }
          alt="merchant banner">
          <Card style={{ borderRadius: 0, width: '100%', margin: 0 }}>
            <CardFooter>
              <Button
                fill
                onClick={() => this.$f7.$('#store_front_hero_image').click()}>
                {this.state.bannerButton} &nbsp;{' '}
                {this.state.bannerButton !== 'Change Banner' && (
                  <Preloader></Preloader>
                )}
              </Button>

              <Button
                outline
                iconF7="gear_alt"
                onClick={() => {
                  this.setState({
                    popupOpened: true,
                    popupDataChanged: true,
                    popupData: {
                      title: 'Store Settings',
                      which: 'store-settings',
                    },
                  });
                }}>
                &nbsp;&nbsp;Store Settings
              </Button>
            </CardFooter>
          </Card>
        </div>
        <input
          type="file"
          name="store-banner"
          id="store_front_hero_image"
          style={{ display: 'none' }}
          onChange={(e) => {
            const reader = new FileReader();
            reader.onload = (ev) => {
              this.setState({
                ...this.state,
                bannerImageDisplay: ev.target.result,
              });
            };
            reader.readAsDataURL(e.target.files[0]);
            this.setState({
              ...this.state,
              banner: {
                ...this.state.banner,
                image: e.target.files[0],
              },
            });
            this.addBanner({ image: e.target.files[0] });
          }}
        />

        <Card
          className="data-table data-table-init"
          style={{ borderRadius: 0, margin: '10pt 0' }}>
          <CardHeader>
            <div className="data-table-title">
              <h2>Menu</h2>
            </div>
            <div className="data-table-actions">
              {/* Todo: onclick add category to merchant database */}
              <Button
                outline
                iconF7="plus_circle"
                onClick={() =>
                  this.$f7.dialog.prompt(
                    'You need a category to place products',
                    'Menu Categories',
                    this.addCategory.bind(this)
                  )
                }>
                &nbsp;&nbsp;&nbsp;Add Category
              </Button>
            </div>
          </CardHeader>
          <CardContent padding={false}>
            <table>
              <thead>
                <tr>
                  {this.props.merchants[this.props.auth.uid].menuCategories &&
                  this.props.merchants[this.props.auth.uid].menuCategories
                    .length !== 0 ? (
                    this.props.merchants[
                      this.props.auth.uid
                    ].menuCategories.map((value, index) => (
                      <th className="label-cell" key={index}>
                        <small onClick={() => this.deleteCategory(index)}>
                          <Icon f7="minus_circle_fill" className="color-red" />
                          &nbsp;&nbsp;{value}
                        </small>
                      </th>
                    ))
                  ) : (
                    <td
                      style={{
                        backgroundColor: '#b3e5ff',
                        borderLeft: '3px solid #03a9f4',
                        color: '#03a9f4',
                        marginTop: 0,
                        paddingTop: '16px',
                        paddingBottom: '16px',
                        width: '100%',
                      }}>
                      <small>You need a category to add products</small>
                    </td>
                  )}
                </tr>
              </thead>
            </table>
          </CardContent>
        </Card>

        {/* Products table */}
        <Card
          className="data-table data-table-init"
          style={{ borderRadius: 0, margin: '10pt 0' }}>
          <CardHeader>
            <div className="data-table-title">Products</div>
            <div className="data-table-actions">
              <Button
                outline
                iconF7="plus_circle"
                onClick={() => {
                  if (!this.props.merchants[this.props.auth.uid].walletId) {
                    this.setState({
                      ...this.state,
                      addProductButton: 'Upload Product Details',
                    });
                    return toast(this.$f7.toast, {
                      text:
                        'Please update your bank details in wallet before adding a product.',
                      position: 'bottom',
                      horizontalPosition: 'center',
                      closeButton: true,
                      cssClass: 'custom-toast',
                      closeTimeout: 4000,
                    });
                  } else {
                    this.setState({
                      popupOpened: true,
                      popupDataChanged: false,
                      popupData: {
                        title: 'Add Product Details',
                        which: 'add-product',
                      },
                      productImageDisplay: null,
                      product: {
                        image: null,
                        name: '',
                        text: '',
                        price: '',
                        discount: '',
                        category: '',
                        available: true,
                        delivery: true,
                        deliveryInclusive: false,
                        stocked: '',
                        preparationTime: 1440,
                        merchantId: this.props.auth.uid,
                        deliveryMeans: 1,
                      },
                    });
                  }
                }}>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Add Product
              </Button>
            </div>
          </CardHeader>
          <CardContent padding={false}>
            {this.props.loadingDoc && this.props.products.length === 0 ? (
              <Block className="text-align-center">
                <Preloader></Preloader>
              </Block>
            ) : !this.props.loadingDoc && this.props.products.length === 0 ? (
              <Block
                style={{
                  backgroundColor: '#b3e5ff',
                  borderLeft: '3px solid #03a9f4',
                  color: '#03a9f4',
                  marginTop: 0,
                  paddingTop: '16px',
                  paddingBottom: '16px',
                }}>
                <small>You don't have a product &nbsp;&nbsp;&nbsp;</small>
              </Block>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th className="checkbox-cell">Product status</th>
                    <th className="label-cell">Product image</th>
                    <th className="label-cell">Product id</th>
                    <th className="input-cell">
                      <span className="table-head-label">Product category</span>
                      <div className="input input-dropdown">
                        <select
                          value={this.state.productFilter.category}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              productFilter: {
                                ...this.state.productFilter,
                                category: e.target.value,
                              },
                            })
                          }>
                          <option value="All">All</option>
                          {this.props.merchants[this.props.auth.uid]
                            .menuCategories &&
                            this.props.merchants[this.props.auth.uid]
                              .menuCategories.length !== 0 &&
                            this.props.merchants[
                              this.props.auth.uid
                            ].menuCategories.map((value, index) => (
                              <option value={value} key={index}>
                                {value}
                              </option>
                            ))}
                        </select>
                      </div>
                    </th>

                    <th className="input-cell">
                      <span className="table-head-label">Product name</span>
                      <div className="input">
                        <input
                          type="text"
                          placeholder="Filter"
                          value={this.state.productFilter.name}
                          onChange={(e) =>
                            this.setState({
                              ...this.state,
                              productFilter: {
                                ...this.state.productFilter,
                                name: e.target.value,
                              },
                            })
                          }
                        />
                      </div>
                    </th>
                    <th className="label-cell">Product price</th>
                    <th className="numeric-cell">Discount</th>
                    <th className="numeric-cell">Stock</th>
                    <th className="label-cell">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.products
                    .filter((p) =>
                      p.name
                        .toLowerCase()
                        .includes(this.state.productFilter.name.toLowerCase())
                    )
                    .filter((p) => {
                      if (this.state.productFilter.category === 'All') {
                        return true;
                      } else {
                        return p.category === this.state.productFilter.category;
                      }
                    })
                    .map(
                      ({
                        id,
                        image: { URL, path },
                        merchantId,
                        name,
                        text,
                        price,
                        discount,
                        stocked,
                        available,
                        category,
                        delivery,
                        deliveryInclusive,
                        deliveryMeans,
                        preparationTime,
                      }) => (
                        <tr
                          key={id}
                          className={
                            available == false
                              ? 'product-offline'
                              : 'product-online'
                          }>
                          <td className="checkbox-cell">
                            <Toggle
                              color="green"
                              id={`product_${id}`}
                              checked={available == false ? false : true}
                              onChange={(e) =>
                                this.productAvailability(e.target.checked, {
                                  id,
                                  available,
                                })
                              }
                            />
                          </td>
                          <td className="label-cell">
                            <img
                              slot="media"
                              src={URL}
                              style={{
                                width: '100px',
                                height: '40px',
                                objectFit: 'cover',
                              }}
                            />
                          </td>
                          <td className="label-cell">{id}</td>
                          <td className="label-cell">
                            <div>{category}</div>
                          </td>
                          <td className="label-cell">
                            <div>{name}</div>
                          </td>
                          <td className="label-cell">
                            <div>
                              {new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'NGN',
                              }).format(price)}
                            </div>
                          </td>
                          <td className="numeric-cell">
                            {discount !== '' ? discount + '.00' : discount}
                          </td>
                          <td className="numeric-cell">
                            {(stocked !== '' && stocked + '.00') || stocked}
                          </td>
                          <td className="label-cell">
                            <Button
                              outline
                              iconF7="pencil_ellipsis_rectangle"
                              onClick={() =>
                                this.setState({
                                  ...this.state,
                                  product: {
                                    ...this.state.product,
                                    id,
                                    image: { URL, path },
                                    name,
                                    text,
                                    price,
                                    discount,
                                    stocked,
                                    category,
                                    available:
                                      available ||
                                      available === null ||
                                      available === undefined
                                        ? true
                                        : false,
                                    delivery,
                                    deliveryInclusive,
                                    deliveryMeans: deliveryMeans
                                      ? deliveryMeans
                                      : 1,
                                    preparationTime,
                                  },
                                  editProduct: true,
                                  productImageDisplay: URL,
                                  popupOpened: true,
                                  popupDataChanged: true,
                                  popupData: {
                                    title: 'Edit Product Details',
                                    which: 'edit-product',
                                  },
                                })
                              }>
                              {' '}
                              &nbsp;&nbsp;&nbsp; Edit
                            </Button>
                          </td>
                        </tr>
                      )
                    )}
                </tbody>
              </table>
            )}
          </CardContent>
        </Card>

        {/* Popup */}
        <Popup
          swipeToClose="to-bottom"
          className="easychaw-popup"
          opened={this.state.popupOpened}
          onPopupClosed={() =>
            this.setState({
              popupOpened: false,
              popupDataChanged: false,
              popupData: { title: '', which: '' },
              productImageDisplay: null,
              product: {
                ...this.state.product,
                image: null,
                name: '',
                text: '',
                price: '',
                discount: '',
                category: '',
                available: true,
                delivery: true,
                deliveryInclusive: false,
                stocked: '',
                preparationTime: 1440,
                deliveryMeans: 1,
              },
            })
          }
          onPopupOpened={(e) => e.app.methods.showFullText()}>
          <Page>
            <Navbar title={this.state.popupData.title}>
              <NavRight>
                <Link popupClose>Close</Link>
              </NavRight>
            </Navbar>

            {/* Content for add/edit product */}
            {this.state.popupData.which == 'add-product' ||
            this.state.popupData.which == 'edit-product' ? (
              <Row noGap>
                {/* [Card-1] Product Image */}
                <Col width="100" medium="50">
                  <Block>
                    <Card style={{ margin: 'auto' }}>
                      <CardContent className="no-padding">
                        <Block
                          className="bg-color-cultured bg-image-pattern"
                          style={{
                            width: '100%',
                            height: '300px',
                            display: 'flex',
                            backgroundSize: '50%',
                            margin: 0,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}>
                          <img
                            src={
                              this.state.productImageDisplay ||
                              'static/icon-512x512@1x.png'
                            }
                            style={{
                              height: '200px',
                              width: '200px',
                              margin: 'auto',
                              objectFit: 'cover',
                              boxShadow: '4px 4px 13px 0px #947c29c9',
                              borderRadius: '10px',
                            }}
                          />
                        </Block>

                        <Block
                          style={{
                            width: '100%',
                            height: '140px',
                            display: 'flex',
                            margin: 0,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderBottom: '1px dashed #f3f3f3',
                          }}>
                          <List noHairlines noHairlinesAurora>
                            <ListInput
                              style={{
                                width: '153px',
                                textAlign: 'center',
                              }}
                              className="custom-file-input"
                              label="Product Image"
                              type="file"
                              placeholder="Please select an image"
                              info="Image formats png|jpg|jpeg"
                              required
                              validate
                              onChange={(e) => {
                                const reader = new FileReader();
                                reader.onload = (ev) => {
                                  this.setState({
                                    ...this.state,
                                    productImageDisplay: ev.target.result,
                                  });
                                };
                                reader.readAsDataURL(e.target.files[0]);
                                this.setState({
                                  ...this.state,
                                  product: {
                                    ...this.state.product,
                                    image: e.target.files[0],
                                  },
                                });
                              }}></ListInput>
                          </List>
                        </Block>
                      </CardContent>
                    </Card>
                  </Block>
                </Col>

                {/* [Card-2] Product Details */}
                <Col width="100" medium="50">
                  <Block>
                    <Card style={{ margin: 'auto' }}>
                      <CardHeader className="no-border">
                        Product Details
                      </CardHeader>
                      <CardContent>
                        <List>
                          <ListInput
                            label="Product Name"
                            type="text"
                            placeholder="Enter product name here"
                            info="Product name is required"
                            required
                            validate
                            value={this.state.product.name}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  name: e.target.value,
                                },
                              })
                            }>
                            <Icon f7="cube_box" slot="media" />
                          </ListInput>

                          <ListInput
                            label="Product Description"
                            type="text"
                            placeholder="A short description of this product..."
                            info="Product description is optional"
                            value={this.state.product.text}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  text: e.target.value,
                                },
                              })
                            }>
                            <Icon f7="pencil_outline" slot="media" />
                          </ListInput>

                          <ListInput
                            label="Product Price"
                            type="number"
                            min="0"
                            placeholder="eg: 5000"
                            info="Product price is required"
                            required
                            validate
                            value={this.state.product.price}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  price: e.target.value
                                    ? parseInt(e.target.value)
                                    : e.target.value,
                                },
                              })
                            }>
                            <Icon f7="creditcard" slot="media" />
                          </ListInput>

                          <ListInput
                            label="Product Category"
                            type="select"
                            placeholder="Please select category to place product"
                            info="Product category is required"
                            value={this.state.product.category}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  category: e.target.value,
                                },
                              })
                            }>
                            <option></option>
                            <option>African Dishes</option>
                            <option>Cakes</option>
                            <option>Chinese Dishes</option>
                            <option>Drinks</option>
                            <option>Foreign Dishes</option>
                            <option>Fruits</option>
                            <option>Shawarma</option>
                            <option>Snacks</option>
                            {this.props.merchants[this.props.auth.uid]
                              .menuCategories
                              ? this.props.merchants[
                                  this.props.auth.uid
                                ].menuCategories.map(
                                  (value, index) =>
                                    ![
                                      'African Dishes',
                                      'Chinese Dishes',
                                      'Foreign Dishes',
                                      'Fruits',
                                      'Drinks',
                                      'Cakes',
                                      'Snacks',
                                      'Shawarma',
                                    ].includes(value) && (
                                      <option key={index}>{value}</option>
                                    )
                                )
                              : null}
                            <Icon f7="layers_alt_fill" slot="media" />
                          </ListInput>

                          <ListInput
                            label="Product Discount"
                            type="number"
                            min="0"
                            max="80"
                            placeholder="0"
                            info="Percentage discount value from 1 to 80 "
                            value={this.state.product.discount}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  discount:
                                    parseInt(e.target.value) <= 80 &&
                                    parseInt(e.target.value) > 0
                                      ? parseInt(e.target.value)
                                      : '',
                                },
                              })
                            }>
                            <Icon f7="percent" slot="media" />
                          </ListInput>

                          <ListInput
                            label="Product Stock"
                            type="number"
                            min="0"
                            placeholder="0"
                            info="Leave field blank if product is always available"
                            value={this.state.product.stocked}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                product: {
                                  ...this.state.product,
                                  stocked:
                                    parseInt(e.target.value) > 0
                                      ? parseInt(e.target.value)
                                      : '',
                                },
                              })
                            }>
                            <Icon f7="square_stack_3d_up_fill" slot="media" />
                          </ListInput>
                        </List>
                      </CardContent>
                    </Card>
                  </Block>
                </Col>

                {/* [Card-3] Product Options */}
                <Col width="100">
                  <Block>
                    <Card style={{ margin: 'auto' }}>
                      <CardHeader className="no-border">
                        Product Options
                      </CardHeader>
                      <CardContent>
                        <List accordionList>
                          <ListItem
                            header="Delivery"
                            title={`Product is for ${
                              this.state.product.delivery
                                ? 'delivery'
                                : 'pickup'
                            } only`}>
                            <Icon f7="car_fill" slot="media" />
                            <Toggle
                              color="green"
                              slot="after"
                              checked={this.state.product.delivery}
                              onChange={(e) =>
                                this.setState({
                                  ...this.state,
                                  product: {
                                    ...this.state.product,
                                    delivery: e.target.checked,
                                    deliveryInclusive: false,
                                  },
                                })
                              }
                            />
                          </ListItem>

                          {this.state.product.delivery && (
                            <ListItem
                              header="Delivery Charge"
                              className="info-on-delivery-type"
                              title={
                                this.state.product.deliveryInclusive
                                  ? 'Inclusive in product'
                                  : 'Standard delivery charge'
                              }>
                              <Link
                                iconF7="info_circle"
                                slot="media"
                                className="glow-tag glow-4x color-blue"
                                onClick={() =>
                                  f7.popover
                                    .create({
                                      content: `<div class="popover padding"> 
                                          ${
                                            this.state.product.deliveryInclusive
                                              ? 'The cost of delivery is included in the product ' +
                                                '<br/><br/>User will not be charged additionally for delivery' +
                                                '<br/><br/>You will have to deliver the item/meal to the user.'
                                              : 'The cost of delivery is not included in the product ' +
                                                '<br/><br/>User will be charged for delivery based on Easychaw rate.'
                                          }
                                        </div>`,
                                      targetEl:
                                        '.info-on-delivery-type .item-media',
                                    })
                                    .open()
                                }
                              />
                              <Toggle
                                color="green"
                                slot="after"
                                checked={this.state.product.deliveryInclusive}
                                onChange={(e) => {
                                  this.setState({
                                    ...this.state,
                                    product: {
                                      ...this.state.product,
                                      deliveryInclusive: e.target.checked,
                                    },
                                  });
                                  f7.methods.glow(
                                    e.target.checked
                                      ? 'color-green'
                                      : 'color-blue'
                                  );
                                }}
                              />
                            </ListItem>
                          )}

                          <ListItem
                            accordionItem
                            header="Product Preparation Time"
                            title={this.preparationTimeComputed}>
                            <Icon f7="alarm" slot="media" />
                            <AccordionContent>
                              <List>
                                <ListItem>
                                  <ListItemCell className="width-auto flex-shrink-0">
                                    <h6> 10 mins</h6>
                                  </ListItemCell>
                                  <ListItemCell className="flex-shrink-3">
                                    <Range
                                      min={10}
                                      max={4320}
                                      step={10}
                                      value={this.state.product.preparationTime}
                                      onRangeChanged={this.setPreparationTime.bind(
                                        this
                                      )}></Range>
                                  </ListItemCell>
                                  <ListItemCell className="width-auto flex-shrink-0">
                                    <h6> 3 days</h6>
                                  </ListItemCell>
                                </ListItem>

                                <ListItem title="Adjust minutes">
                                  <Icon f7="alarm" slot="media" />
                                  <Stepper
                                    min={10}
                                    max={4320}
                                    step={10}
                                    value={this.state.product.preparationTime}
                                    buttonsOnly={true}
                                    small
                                    fill
                                    round
                                    slot="after"
                                    onStepperChange={this.setPreparationTime.bind(
                                      this
                                    )}></Stepper>
                                </ListItem>
                              </List>
                            </AccordionContent>
                          </ListItem>
                        </List>
                      </CardContent>
                      {!this.state.product.delivery ? (
                        <CardFooter>
                          {this.state.popupData.which == 'add-product' ? (
                            <Button
                              round
                              fill
                              style={{ width: '100%' }}
                              onClick={this.addProduct.bind(this)}>
                              {this.state.addProductButton} &nbsp;{' '}
                              {this.state.addProductButton !==
                                'Upload Product Details' && (
                                <Preloader></Preloader>
                              )}
                            </Button>
                          ) : (
                            <>
                              <Button
                                fill
                                className="button-fill-red"
                                style={{
                                  maxWidth: '41px',
                                }}
                                iconF7="trash"
                                onClick={() =>
                                  this.deleteProduct(
                                    this.state.product.id,
                                    this.state.product.image.path
                                  )
                                }></Button>

                              <Button
                                className="button-fill-blue"
                                round
                                fill
                                style={{ width: '45%' }}
                                onClick={() => this.editProduct()}>
                                Save Product
                              </Button>
                            </>
                          )}
                        </CardFooter>
                      ) : null}
                    </Card>
                  </Block>
                </Col>

                {/* [Card-4] Product Delivery Means */}
                {this.state.product.delivery ? (
                  <Col width="100">
                    <Block>
                      <Card style={{ margin: 'auto' }}>
                        <CardHeader className="no-border">
                          Product Delivery Means
                        </CardHeader>
                        <CardContent
                          className="bg-color-cultured"
                          style={{ padding: '8px' }}>
                          <Row>
                            <Col width="50">
                              <Card style={{ margin: '8px' }}>
                                <CardHeader
                                  style={
                                    this.state.product.deliveryMeans == 1
                                      ? { background: '#fed448' }
                                      : null
                                  }>
                                  Bike Delivery
                                </CardHeader>
                                <CardContent>
                                  <img
                                    src="static/bike.svg"
                                    alt="bike"
                                    style={{
                                      height: '60px',
                                      width: '100%',
                                    }}
                                  />
                                </CardContent>
                                <CardFooter>
                                  <Button
                                    fill
                                    style={
                                      this.state.product.deliveryMeans == 1
                                        ? { width: '100%' }
                                        : {
                                            width: '100%',
                                            background: '#cacaca',
                                            color: '#ffffff',
                                          }
                                    }
                                    onClick={() =>
                                      this.setState({
                                        ...this.state,
                                        product: {
                                          ...this.state.product,
                                          deliveryMeans: 1,
                                        },
                                      })
                                    }
                                    color="theme">
                                    {this.state.product.deliveryMeans === 1 ? (
                                      <Icon f7="checkmark_circle_fill"></Icon>
                                    ) : (
                                      'Select'
                                    )}
                                  </Button>
                                </CardFooter>
                              </Card>
                            </Col>
                            <Col width="50">
                              <Card style={{ margin: '8px' }}>
                                <CardHeader
                                  style={
                                    this.state.product.deliveryMeans == 2
                                      ? { background: '#fed448' }
                                      : null
                                  }>
                                  Car Delivery
                                </CardHeader>
                                <CardContent>
                                  <img
                                    src="static/car.svg"
                                    alt="car"
                                    style={{
                                      height: '60px',
                                      width: '100%',
                                    }}
                                  />
                                </CardContent>
                                <CardFooter>
                                  <Button
                                    fill
                                    style={
                                      this.state.product.deliveryMeans == 2
                                        ? { width: '100%' }
                                        : {
                                            width: '100%',
                                            background: '#cacaca',
                                            color: '#ffffff',
                                          }
                                    }
                                    onClick={() =>
                                      this.setState({
                                        ...this.state,
                                        product: {
                                          ...this.state.product,
                                          deliveryMeans: 2,
                                        },
                                      })
                                    }
                                    color="gray">
                                    {this.state.product.deliveryMeans === 2 ? (
                                      <Icon f7="checkmark_circle_fill"></Icon>
                                    ) : (
                                      'Select'
                                    )}
                                  </Button>
                                </CardFooter>
                              </Card>
                            </Col>
                          </Row>
                        </CardContent>
                        <CardFooter>
                          {this.state.popupData.which == 'add-product' ? (
                            <Button
                              round
                              fill
                              style={{ width: '100%' }}
                              onClick={this.addProduct.bind(this)}>
                              {this.state.addProductButton} &nbsp;{' '}
                              {this.state.addProductButton !==
                                'Upload Product Details' && (
                                <Preloader></Preloader>
                              )}
                            </Button>
                          ) : (
                            <>
                              <Button
                                fill
                                className="button-fill-red"
                                style={{
                                  maxWidth: '41px',
                                }}
                                iconF7="trash"
                                onClick={() =>
                                  this.deleteProduct(
                                    this.state.product.id,
                                    this.state.product.image.path
                                  )
                                }></Button>

                              <Button
                                className="button-fill-blue"
                                round
                                fill
                                style={{ width: '45%' }}
                                onClick={() => this.editProduct()}>
                                Save Product
                              </Button>
                            </>
                          )}
                        </CardFooter>
                      </Card>
                    </Block>
                  </Col>
                ) : null}
              </Row>
            ) : null}

            {/* Content for store settings */}
            {this.state.popupData.which == 'store-settings' ? (
              <Block>
                <Card style={{ margin: 'auto' }}>
                  <CardHeader className="no-border">
                    Merchant Status
                    <Button popoverOpen=".info-popover">
                      <Icon f7="info_circle" />
                    </Button>
                  </CardHeader>
                  <CardContent>
                    <List>
                      <ListItem
                        header="Availability"
                        title="(turn off if you offline)">
                        <Icon f7="lightbulb_fill" slot="media" />
                        <Toggle
                          slot="after"
                          color="green"
                          defaultChecked={
                            this.props.merchants[this.props.auth.uid]
                              .currentStatus &&
                            this.props.merchants[this.props.auth.uid]
                              .currentStatus === 'online'
                          }
                          onToggleChange={(e) => this.updateCurrentStatus(e)}
                        />
                      </ListItem>
                    </List>
                  </CardContent>
                </Card>

                {/* <Card style={{ margin: '20pt auto' }}>
                  <CardHeader className="no-border">Operating Times</CardHeader>
                  <CardContent>
                    <List>
                      <ListInput
                        label="Business Opening Time"
                        type="select"
                        placeholder="Please select opening time"
                        info="Select time from dropdown"
                        value={
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.operationStartTime &&
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.operationStartTime
                        }
                        onChange={(e) =>
                          this.updateOperationTime(e.target.value, 'open')
                        }>
                        {this.state.operatingTime.map((time, i) => (
                          <option key={i} value={time}>
                            {time}
                          </option>
                        ))}
                        <Icon f7="timer" slot="media" />
                      </ListInput>

                      <ListInput
                        label="Business Closing Time"
                        type="select"
                        placeholder="Please select closing time"
                        info="Select time from dropdown"
                        value={
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.operationCloseTime &&
                          this.props.merchants[this.props.auth.uid]
                            .businessProfile.operationCloseTime
                        }
                        onChange={(e) =>
                          this.updateOperationTime(e.target.value, 'close')
                        }>
                        {this.state.operatingTime.map((time, i) => (
                          <option key={i} value={time}>
                            {time}
                          </option>
                        ))}
                        <Icon f7="timer" slot="media" />
                      </ListInput>
                    </List>
                  </CardContent>
                </Card>

                <Card style={{ margin: '20pt auto' }}>
                  <CardHeader className="no-border">Operating Days</CardHeader>
                  <CardContent>
                    <List>
                      {this.state.operatingDays.map((day, i) => (
                        <ListItem
                          checkbox
                          checked={
                            this.props.merchants[this.props.auth.uid]
                              .businessProfile.operationDays &&
                            this.props.merchants[
                              this.props.auth.uid
                            ].businessProfile.operationDays.includes(day)
                          }
                          onChange={(e) => this.updateOperationDays(e, day)}
                          name="days-checkbox"
                          key={i}
                          value={day}
                          title={day}></ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
               */}
                <Card style={{ margin: '20pt auto' }}>
                  <CardHeader className="no-border">Available Days</CardHeader>
                  <CardContent>
                    {Object.entries(this.state.storeAvailable).map((v, i) => (
                      <Card
                        style={{ margin: 'auto', marginBottom: '20pt' }}
                        key={i}>
                        <CardHeader className="no-border no-padding">
                          <List style={{ width: '100%' }}>
                            <ListItem
                              checkbox
                              checked={this.props.merchants[
                                this.props.auth.uid
                              ].businessProfile?.operationDays?.includes(v[0])}
                              value={v[0]}
                              title={v[0]}
                              onChange={(e) =>
                                this.updateOperationDays(e, v[0])
                              }></ListItem>
                          </List>
                        </CardHeader>
                        {this.props.merchants[
                          this.props.auth.uid
                        ].businessProfile?.operationDays?.includes(v[0]) && (
                          <CardContent className="no-padding">
                            <Row>
                              <Col width="50">
                                <List>
                                  <ListInput
                                    label="Opening Time"
                                    type="select"
                                    placeholder="Opening time"
                                    value={
                                      this.props.merchants[this.props.auth.uid]
                                        .businessProfile?.operationTimes?.[v[0]]
                                        ?.open ||
                                      this.props.merchants[this.props.auth.uid]
                                        .businessProfile?.operationStartTime
                                    }
                                    onChange={(e) =>
                                      this.updateOperationTime(
                                        e.target.value,
                                        'open',
                                        v[0]
                                      )
                                    }>
                                    {this.state.operatingTime.map((time, i) => (
                                      <option key={i} value={time}>
                                        {time}
                                      </option>
                                    ))}
                                  </ListInput>
                                </List>
                              </Col>
                              <Col width="50">
                                <List>
                                  <ListInput
                                    label="Closing Time"
                                    type="select"
                                    placeholder="Closing time"
                                    value={
                                      this.props.merchants[this.props.auth.uid]
                                        .businessProfile?.operationTimes?.[v[0]]
                                        ?.close ||
                                      this.props.merchants[this.props.auth.uid]
                                        .businessProfile?.operationCloseTime
                                    }
                                    onChange={(e) =>
                                      this.updateOperationTime(
                                        e.target.value,
                                        'close',
                                        v[0]
                                      )
                                    }>
                                    {this.state.operatingTime.map((time, i) => (
                                      <option key={i} value={time}>
                                        {time}
                                      </option>
                                    ))}
                                  </ListInput>
                                </List>
                              </Col>
                            </Row>
                          </CardContent>
                        )}
                      </Card>
                    ))}
                  </CardContent>
                </Card>
              </Block>
            ) : null}
          </Page>
        </Popup>

        <Popover className="info-popover">
          <Block style={{ textAlign: 'center' }}>
            <p>
              Note: Your store front page would be offline, users will not be
              able to see your page if you turn this off!
            </p>
          </Block>
        </Popover>
      </Page>
    );
  }

  // events
  navMessage(...args) {
    const self = this;
    const messageReceiverID = args[1] ? args[1] : 'admin';
    const previousView = args[0] ? args[0] : 'account';
    const previousPage = args[2] ? args[2] : 'account';

    self.$f7.views['message-master'].router.navigate(
      {
        name: 'message-master',
        params: {
          view: previousView,
          id: messageReceiverID,
          page: previousPage,
        },
      },
      {
        reloadAll: true,
      }
    );
  }

  updateCurrentStatus(status) {
    this.$f7.preloader.show();
    let currentStatus = status ? 'online' : 'offline';
    this.props.firestore
      .collection('merchants')
      .doc(this.props.auth.uid)
      .update({ currentStatus })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();

        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  updateOperationTime(time, when, day) {
    this.$f7.preloader.show();

    const update = {
      ...this.props.merchants[this.props.auth.uid].businessProfile,
      operationTimes: this.props.merchants[this.props.auth.uid].businessProfile
        .operationTimes
        ? {
            ...this.props.merchants[this.props.auth.uid].businessProfile
              .operationTimes,
            [day]: {
              ...this.props.merchants[this.props.auth.uid].businessProfile
                .operationTimes?.[day],
              [when]: time,
            },
          }
        : {
            [day]: {
              [when]: time,
            },
          },
    };

    this.props.firestore
      .collection('merchants')
      .doc(this.props.auth.uid)
      .update({ businessProfile: update })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  updateOperationDays(e, day) {
    this.$f7.preloader.show();
    const update = {
      ...this.props.merchants[this.props.auth.uid].businessProfile,
    };

    if (e.target.checked) {
      update.operationDays = this.props.merchants[this.props.auth.uid]
        .businessProfile.operationDays
        ? [
            ...this.props.merchants[this.props.auth.uid].businessProfile
              .operationDays,
            day,
          ]
        : [day];
    } else {
      update.operationDays = update.operationDays.filter((d) => d !== day);
    }

    this.props.firestore
      .collection('merchants')
      .doc(this.props.auth.uid)
      .update({ businessProfile: update })
      .then(() => {
        this.$f7.preloader.hide();
      })
      .catch((error) => {
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  addBanner(banner) {
    this.$f7.preloader.show();
    this.setState({ ...this.state, bannerButton: '' });

    // image
    // image type validation
    if (!['image/jpg', 'image/jpeg', 'image/png'].includes(banner.image.type)) {
      this.setState({ ...this.state, bannerButton: 'Change Banner' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Please select a valid image for your store banner.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // Validate image size
    if (banner.image.size > 10000000) {
      this.setState({ ...this.state, bannerButton: 'Change Banner' });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Maximum image size: 10MB.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // Check if merchant has a banner
    if (this.props.merchants[this.props.auth.uid].banner) {
      // delete the banner and add new one
      deleteFile(
        this.props.storage,
        this.props.merchants[this.props.auth.uid].banner.path,
        (error) => {
          if (error && error.code !== 'storage/object-not-found') {
            this.setState({ ...this.state, bannerButton: 'Change Banner' });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }
          uploadFile(
            this.props.storage,
            'banners',
            this.props.auth.uid,
            banner.image,
            (error, imageDetails) => {
              if (error) {
                this.setState({ ...this.state, bannerButton: 'Change Banner' });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }

              this.props.firestore
                .collection('merchants')
                .doc(this.props.auth.uid)
                .update({ banner: imageDetails })
                .then(() => {
                  this.setState({
                    ...this.state,
                    bannerButton: 'Change Banner',
                    banner: { image: null },
                    bannerImageDisplay: null,
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: 'Banner Uploaded',
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    bannerButton: 'Change Banner',
                    banner: { image: null },
                    bannerImageDisplay: null,
                  });
                  this.$f7.preloader.hide();
                  toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                });
            }
          );
        }
      );
    } else {
      // add banner
      uploadFile(
        this.props.storage,
        'banners',
        this.props.auth.uid,
        banner.image,
        (error, imageDetails) => {
          if (error) {
            this.setState({ ...this.state, bannerButton: 'Change Banner' });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          this.props.firestore
            .collection('merchants')
            .doc(this.props.auth.uid)
            .update({ banner: imageDetails })
            .then(() => {
              this.setState({
                ...this.state,
                bannerButton: 'Change Banner',
                banner: { image: null },
                bannerImageDisplay: null,
              });
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: 'Banner Uploaded',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            })
            .catch((error) => {
              this.setState({
                ...this.state,
                bannerButton: 'Change Banner',
                banner: { image: null },
                bannerImageDisplay: null,
              });
              this.$f7.preloader.hide();
              toast(this.$f7.toast, {
                text: handleErrors(error),
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            });
        }
      );
    }
  }

  addProduct() {
    this.$f7.preloader.show();
    this.setState({ ...this.state, addProductButton: '' });
    const product = {
      ...this.state.product,
    };

    // validate fields

    // image
    if (product.image === null) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Please select an image for your product.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // image type validation
    if (
      !['image/jpg', 'image/jpeg', 'image/png'].includes(product.image.type)
    ) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Please select a valid image for your product.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // Validate image size
    if (product.image.size > 10000000) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Maximum image size: 10MB.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (isEmpty(product.name)) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Product name is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (isEmpty(product.category)) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text:
          'Product category is required! Exit Product Editor and Add Category.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (!product.price) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Product price is required.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    if (isNaN(parseFloat(product.price)) || parseFloat(product.price) < 1) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Product price is invalid.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // check count
    if (
      product.stocked !== '' &&
      (isNaN(parseInt(product.stocked)) || parseInt(product.stocked) < 1)
    ) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Product stock is invalid.',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    // check discount
    if (
      product.discount !== '' &&
      (isNaN(parseInt(product.discount)) ||
        parseInt(product.discount) < 1 ||
        parseInt(product.discount) > 80)
    ) {
      this.setState({
        ...this.state,
        addProductButton: 'Upload Product Details',
      });
      this.$f7.preloader.hide();
      return toast(this.$f7.toast, {
        text: 'Product discount is invalid. Enter value 1 - 80',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    uploadFile(
      this.props.storage,
      'products',
      this.props.auth.uid,
      product.image,
      (error, imageObject) => {
        if (error) {
          this.setState({
            ...this.state,
            addProductButton: 'Upload Product Details',
          });
          this.$f7.preloader.hide();
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        }

        product.image = imageObject;
        this.props.firestore
          .collection('products')
          .doc(generateId(7))
          .set(product)
          .then((doc) => {
            if (
              !this.props.merchants[this.props.auth.uid].menuCategories ||
              !this.props.merchants[
                this.props.auth.uid
              ].menuCategories.includes(this.state.product.category)
            ) {
              this.props.firestore
                .collection('merchants')
                .doc(this.props.auth.uid)
                .update({
                  menuCategories: !this.props.merchants[this.props.auth.uid]
                    .menuCategories
                    ? [this.state.product.category]
                    : [
                        ...this.props.merchants[this.props.auth.uid]
                          .menuCategories,
                        this.state.product.category,
                      ],
                })
                .then(() => {
                  this.setState({
                    ...this.state,
                    popupOpened: false,
                    addProductButton: 'Upload Product Details',
                    productImageDisplay: null,
                    product: {
                      ...this.state.product,
                      image: null,
                      name: '',
                      text: '',
                      price: '',
                      discount: '',
                      category: '',
                      delivery: true,
                      stocked: '',
                    },
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: 'Product Uploaded',
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                })
                .catch((error) => {
                  this.setState({
                    ...this.state,
                    addProductButton: 'Upload Product Details',
                  });
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                });
            } else {
              this.setState({
                ...this.state,
                popupOpened: false,
                addProductButton: 'Upload Product Details',
                productImageDisplay: null,
                product: {
                  ...this.state.product,
                  image: null,
                  name: '',
                  text: '',
                  price: '',
                  discount: '',
                  category: '',
                  available: true,
                  delivery: true,
                  stocked: '',
                  preparationTime: 1440,
                },
              });
              this.$f7.preloader.hide();
              return toast(this.$f7.toast, {
                text: 'Product Uploaded',
                position: 'bottom',
                horizontalPosition: 'center',
                closeButton: true,
                cssClass: 'custom-toast',
                closeTimeout: 4000,
              });
            }
          })
          .catch((error) => {
            this.setState({
              ...this.state,
              addProductButton: 'Upload Product Details',
            });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          });
      }
    );
  }

  editProduct() {
    this.$f7.preloader.show();
    const product = {
      ...this.state.product,
    };
    const editedfilters = {};

    // check to see if image is checked
    if (!product.image.URL) {
      // validate fields

      // image
      if (product.image === null) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Please select an image for your product.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      // image type validation
      if (
        !['image/jpg', 'image/jpeg', 'image/png'].includes(product.image.type)
      ) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Please select a valid image for your product.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      // Validate image size
      if (product.image.size > 10000000) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Maximum image size: 10MB.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      // if (isNaN(parseFloat(product.price)) || parseFloat(product.price) < 1) {
      //   this.setState({
      //     ...this.state,
      //     addProductButton: 'Upload Product Details',
      //   });
      //   this.$f7.preloader.hide();
      //   return toast(this.$f7.toast, {
      //     text: 'Product price is invalid.',
      //     position: 'bottom',
      //     horizontalPosition: 'center',
      //     closeButton: true,
      //     cssClass: 'custom-toast',
      //     closeTimeout: 4000,
      //   });
      // }

      // // check count
      // if (
      //   product.stocked !== '' &&
      //   (isNaN(parseInt(product.stocked)) || parseInt(product.stocked) < 1)
      // ) {
      //   this.setState({
      //     ...this.state,
      //     addProductButton: 'Upload Product Details',
      //   });
      //   this.$f7.preloader.hide();
      //   return toast(this.$f7.toast, {
      //     text: 'Product stock is invalid.',
      //     position: 'bottom',
      //     horizontalPosition: 'center',
      //     closeButton: true,
      //     cssClass: 'custom-toast',
      //     closeTimeout: 4000,
      //   });
      // }

      // // check discount
      // if (
      //   product.discount !== '' &&
      //   (isNaN(parseInt(product.discount)) ||
      //     parseInt(product.discount) < 1 ||
      //     parseInt(product.discount) > 80)
      // ) {
      //   this.setState({
      //     ...this.state,
      //     addProductButton: 'Upload Product Details',
      //   });
      //   this.$f7.preloader.hide();
      //   return toast(this.$f7.toast, {
      //     text: 'Product discount is invalid. Enter value 1 - 80',
      //     position: 'bottom',
      //     horizontalPosition: 'center',
      //     closeButton: true,
      //     cssClass: 'custom-toast',
      //     closeTimeout: 4000,
      //   });
      // }

      editedfilters.image = product.image;
    }

    // get updated fields
    Object.keys(product).forEach((key) => {
      if (key !== 'image') {
        if (
          product[key] !==
          this.props.products.find((p) => p.id === product.id)[key]
        ) {
          editedfilters[key] = product[key];
        }
      }
    });

    let errorCount = 0;

    // validate updated fields
    Object.keys(editedfilters).forEach((key) => {
      if (key === 'name' && isEmpty(product.name)) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        errorCount++;
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Product name is required.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      if (key === 'category' && isEmpty(product.category)) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        errorCount++;
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text:
            'Product category is required! Exit Product Editor and Add Category.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      if (key === 'price' && !product.price) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        this.$f7.preloader.hide();
        errorCount++;
        return toast(this.$f7.toast, {
          text: 'Product price is required.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      if (
        key === 'price' &&
        (isNaN(parseFloat(product.price)) || parseFloat(product.price) < 1)
      ) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        errorCount++;
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Product price is invalid.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      // check count
      if (
        key === 'stocked' &&
        product.stocked !== '' &&
        (isNaN(parseInt(product.stocked)) || parseInt(product.stocked) < 1)
      ) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        errorCount++;
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Product stock is invalid.',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }

      // check discount
      if (
        key === 'discount' &&
        product.discount !== '' &&
        (isNaN(parseInt(product.discount)) ||
          parseInt(product.discount) < 1 ||
          parseInt(product.discount) > 80)
      ) {
        this.setState({
          ...this.state,
          addProductButton: 'Upload Product Details',
        });
        errorCount++;
        this.$f7.preloader.hide();
        return toast(this.$f7.toast, {
          text: 'Product discount is invalid. Enter value 1 - 80',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      }
    });

    if (errorCount > 0) {
      return false;
    }

    // check if user changed image
    if (editedfilters.image) {
      // delete old image
      deleteFile(
        this.props.storage,
        this.props.products.find((p) => p.id === product.id).image.path,
        (error) => {
          if (error && error.code !== 'storage/object-not-found') {
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: handleErrors(error),
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }

          uploadFile(
            this.props.storage,
            'products',
            this.props.auth.uid,
            editedfilters.image,
            (error, imageObject) => {
              if (error) {
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              }

              editedfilters.image = imageObject;
              this.props.firestore
                .collection('products')
                .doc(product.id)
                .update(editedfilters)
                .then((doc) => {
                  if (
                    !this.props.merchants[this.props.auth.uid].menuCategories ||
                    !this.props.merchants[
                      this.props.auth.uid
                    ].menuCategories.includes(product.category)
                  ) {
                    this.props.firestore
                      .collection('merchants')
                      .doc(this.props.auth.uid)
                      .update({
                        menuCategories: !this.props.merchants[
                          this.props.auth.uid
                        ].menuCategories
                          ? [product.category]
                          : [
                              ...this.props.merchants[this.props.auth.uid]
                                .menuCategories,
                              product.category,
                            ],
                      })
                      .then(() => {
                        this.setState({
                          ...this.state,
                          popupOpened: false,
                          productImageDisplay: null,
                          product: {
                            ...this.state.product,
                            image: null,
                            name: '',
                            text: '',
                            price: '',
                            discount: '',
                            category: '',
                            available: true,
                            delivery: true,
                            stocked: '',
                            preparationTime: 1440,
                          },
                        });
                        this.$f7.preloader.hide();
                        return toast(this.$f7.toast, {
                          text: 'Product Updated',
                          position: 'bottom',
                          horizontalPosition: 'center',
                          closeButton: true,
                          cssClass: 'custom-toast',
                          closeTimeout: 4000,
                        });
                      })
                      .catch((error) => {
                        this.setState({
                          ...this.state,
                        });
                        this.$f7.preloader.hide();
                        return toast(this.$f7.toast, {
                          text: handleErrors(error),
                          position: 'bottom',
                          horizontalPosition: 'center',
                          closeButton: true,
                          cssClass: 'custom-toast',
                          closeTimeout: 4000,
                        });
                      });
                  } else {
                    this.setState({
                      ...this.state,
                      popupOpened: false,
                      productImageDisplay: null,
                      product: {
                        ...this.state.product,
                        image: null,
                        name: '',
                        text: '',
                        price: '',
                        discount: '',
                        category: '',
                        available: true,
                        delivery: true,
                        stocked: '',
                        preparationTime: 1440,
                      },
                    });
                    this.$f7.preloader.hide();
                    return toast(this.$f7.toast, {
                      text: 'Product Updated',
                      position: 'bottom',
                      horizontalPosition: 'center',
                      closeButton: true,
                      cssClass: 'custom-toast',
                      closeTimeout: 4000,
                    });
                  }
                })
                .catch((error) => {
                  this.$f7.preloader.hide();
                  return toast(this.$f7.toast, {
                    text: handleErrors(error),
                    position: 'bottom',
                    horizontalPosition: 'center',
                    closeButton: true,
                    cssClass: 'custom-toast',
                    closeTimeout: 4000,
                  });
                });
            }
          );
        }
      );
    } else {
      this.props.firestore
        .collection('products')
        .doc(product.id)
        .update(editedfilters)
        .then((doc) => {
          if (
            !this.props.merchants[this.props.auth.uid].menuCategories ||
            !this.props.merchants[this.props.auth.uid].menuCategories.includes(
              product.category
            )
          ) {
            this.props.firestore
              .collection('merchants')
              .doc(this.props.auth.uid)
              .update({
                menuCategories: !this.props.merchants[this.props.auth.uid]
                  .menuCategories
                  ? [product.category]
                  : [
                      ...this.props.merchants[this.props.auth.uid]
                        .menuCategories,
                      product.category,
                    ],
              })
              .then(() => {
                this.setState({
                  ...this.state,
                  popupOpened: false,
                  productImageDisplay: null,
                  product: {
                    ...this.state.product,
                    image: null,
                    name: '',
                    text: '',
                    price: '',
                    discount: '',
                    category: '',
                    available: true,
                    delivery: true,
                    stocked: '',
                    preparationTime: 1440,
                  },
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: 'Product Updated',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              })
              .catch((error) => {
                this.setState({
                  ...this.state,
                });
                this.$f7.preloader.hide();
                return toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
              });
          } else {
            this.setState({
              ...this.state,
              popupOpened: false,
              productImageDisplay: null,
              product: {
                ...this.state.product,
                image: null,
                name: '',
                text: '',
                price: '',
                discount: '',
                category: '',
                available: true,
                delivery: true,
                stocked: '',
                preparationTime: 1440,
              },
            });
            this.$f7.preloader.hide();
            return toast(this.$f7.toast, {
              text: 'Product Updated',
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          }
        })
        .catch((error) => {
          this.$f7.preloader.hide();
          return toast(this.$f7.toast, {
            text: handleErrors(error),
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        });
    }
  }

  deleteProduct(productId, path) {
    this.$f7.dialog.confirm(
      'This product will be deleted from your page!',
      () => {
        this.$f7.preloader.show();
        deleteFile(this.props.storage, path, (error) => {
          if (error && error.code !== 'storage/object-not-found') {
            this.$f7.preloader.hide();
            toast(this.$f7.toast, {
              text: 'Something went wrong',
              position: 'bottom',
              horizontalPosition: 'center',
              closeButton: true,
              cssClass: 'custom-toast',
              closeTimeout: 4000,
            });
          } else {
            this.props.firestore
              .collection('products')
              .doc(productId)
              .delete()
              .then(() => {
                toast(this.$f7.toast, {
                  text: 'Product deleted',
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
                this.setState({
                  ...this.state,
                  popupOpened: false,
                  productImageDisplay: null,
                  product: {
                    ...this.state.product,
                    image: null,
                    name: '',
                    text: '',
                    price: '',
                    discount: '',
                    category: '',
                    available: true,
                    delivery: true,
                    stocked: '',
                    preparationTime: 1440,
                  },
                });
                this.$f7.preloader.hide();
              })
              .catch((error) => {
                toast(this.$f7.toast, {
                  text: handleErrors(error),
                  position: 'bottom',
                  horizontalPosition: 'center',
                  closeButton: true,
                  cssClass: 'custom-toast',
                  closeTimeout: 4000,
                });
                this.$f7.preloader.hide();
              });
          }
        });
      }
    );
  }

  productAvailability(checked, product) {
    const self = this;
    const app = self.$f7;
    let text = '';
    const updateProduct = {
      available: checked,
    };

    !checked
      ? (text = 'Product will not be shown in your store if you turn this off.')
      : (text = 'Product will be shown in your store if you turn this on.');
    app.dialog.confirm(text, 'Product Avalability', () => {
      app.preloader.hide();

      self.props.firestore
        .collection('products')
        .doc(product.id)
        .update(updateProduct)
        .then((doc) => {
          app.preloader.hide();
          return toast(app.toast, {
            text: 'Product Updated',
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        })
        .catch((error) => {
          app.preloader.hide();
          return toast(app.toast, {
            text: handleErrors(error),
            position: 'bottom',
            horizontalPosition: 'center',
            closeButton: true,
            cssClass: 'custom-toast',
            closeTimeout: 4000,
          });
        });
      // -- end of produt update
    });
  }

  addCategory(value) {
    if (isEmpty(value)) {
      return toast(this.$f7.toast, {
        text: 'Menu category name is required!',
        position: 'bottom',
        horizontalPosition: 'center',
        closeButton: true,
        cssClass: 'custom-toast',
        closeTimeout: 4000,
      });
    }

    let update;

    if (this.props.merchants[this.props.auth.uid].menuCategories) {
      // Check if category already exists
      if (
        this.props.merchants[this.props.auth.uid].menuCategories.filter(
          (category) => category.toLowerCase() === value.toLowerCase()
        ).length > 0
      ) {
        return this.$f7.dialog.alert('Category already exists');
      } else {
        // update mechant menuCategory db
        update = this.props.merchants[this.props.auth.uid].menuCategories;
        update.push(value);
      }
    } else {
      // adding menu category for the first time
      update = [value];
    }

    this.props.firestore
      .collection('merchants')
      .doc(this.props.auth.uid)
      .update({ menuCategories: update })
      .then(() => {
        return toast(this.$f7.toast, {
          text: 'Menu category added successfully',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }

  deleteCategory(index) {
    var update = this.props.merchants[this.props.auth.uid].menuCategories;
    update.splice(index, 1);

    this.props.firestore
      .collection('merchants')
      .doc(this.props.auth.uid)
      .update({ menuCategories: update })
      .then(() => {
        return toast(this.$f7.toast, {
          text: 'Menu category deleted successfully',
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      })
      .catch((error) => {
        toast(this.$f7.toast, {
          text: handleErrors(error),
          position: 'bottom',
          horizontalPosition: 'center',
          closeButton: true,
          cssClass: 'custom-toast',
          closeTimeout: 4000,
        });
      });
  }
}

const mapStateToProps = ({
  firebase: { auth },
  DB: {
    docs: { products, loading },
    data: { settings },
  },
}) => ({
  auth,
  products: (products && products) || [],
  loadingDoc: loading,
  settings,
});

const enhance = compose(
  withStorage,
  firestoreConnect((props) => [
    new DocArray('products', props.auth.uid, 'merchantId'),
    new Collections('settings'),
  ]),
  connect(mapStateToProps)
);

export default enhance(MerchantProducts);
